import {
  ABS,
  BLIND_SPOT_MONITOR,
  BRAKE_ASSIST,
  CENTRAL_LOCKING,
  COLLISION_WARNING_SYSTEM,
  CRUISE_CONTROL,
  ESP,
  FOUR_WHEEL_DRIVE,
  IMMOBILIZER,
  LANE_CHANGE_ASSIST,
  LANE_DEPARTURE_WARNING_SYSTEM,
  TRACTION_CONTROL,
  HAS_EMERGENCY_CALL_SYSTEM,
  HAS_SELF_PARKING_SYSTEM,
  HAS_CRUISE_CONTROL,
} from './values';

import { prepareSortedOptions } from '../../prepareOptions';

export default prepareSortedOptions([
  {
    value: CENTRAL_LOCKING,
    label: __('carDetails.equipmentGroups.powerDoorLocks'),
  },
  {
    value: ABS,
    label: __('carDetails.equipmentGroups.abs'),
  },
  {
    value: BLIND_SPOT_MONITOR,
    label: __('carDetails.equipmentGroups.blindSpotAssist'),
  },
  {
    value: COLLISION_WARNING_SYSTEM,
    label: __('carDetails.equipmentGroups.collisionWarningSystem'),
  },
  {
    value: ESP,
    label: __('carDetails.equipmentGroups.esp'),
  },
  {
    value: IMMOBILIZER,
    label: __('carDetails.equipmentGroups.immobilizer'),
  },
  {
    value: TRACTION_CONTROL,
    label: __('carDetails.equipmentGroups.tractionControl'),
  },
  {
    value: FOUR_WHEEL_DRIVE,
    label: __('carDetails.equipmentGroups.allWheelDrive'),
  },
  {
    value: LANE_DEPARTURE_WARNING_SYSTEM,
    label: __('carDetails.equipmentGroups.laneAssist'),
  },
  {
    value: LANE_CHANGE_ASSIST,
    label: __('carDetails.equipmentGroups.laneChangeAssistant'),
  },
  {
    value: BRAKE_ASSIST,
    label: __('carDetails.equipmentGroups.brakeAssist'),
  },
  {
    value: CRUISE_CONTROL,
    label: __('carDetails.equipmentGroups.adoptiveCruiseControl'),
  },
  {
    value: HAS_EMERGENCY_CALL_SYSTEM,
    label: __('carDetails.features.hasEmergencyCallSystem'),
  },
  {
    value: HAS_SELF_PARKING_SYSTEM,
    label: __('carDetails.features.hasSelfParkingSystem'),
  },
  {
    value: HAS_CRUISE_CONTROL,
    label: __('carDetails.features.hasCruiseControl'),
  },
]);
